'use client';

import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { useTranslations } from 'next-intl';

import { EmptyState } from '@/components/EmptyState';

interface ErrorStateProps {
  title?: string;
  subtitle?: string;
}

export default function ErrorState({ title, subtitle }: ErrorStateProps) {
  const t = useTranslations('Index.ErrorState');

  return (
    <EmptyState
      error
      icon={<ErrorOutline />}
      title={title || t('title')}
      subtitle={subtitle || t('subtitle')}
    />
  );
}
